import { render, staticRenderFns } from "./ManageSelectedMessages.vue?vue&type=template&id=4577be56&scoped=true&lang=pug"
import script from "./ManageSelectedMessages.vue?vue&type=script&lang=js"
export * from "./ManageSelectedMessages.vue?vue&type=script&lang=js"
import style0 from "./ManageSelectedMessages.vue?vue&type=style&index=0&id=4577be56&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4577be56",
  null
  
)

export default component.exports